<template>
  <bvue-ui-view class="flex items-center justify-center fullPage z-10">
    <div class="session-container flex flex-col">
      <div class="flex justify-end">
        <button id="cerrarcruzregistro" class="icon icon-cross icon-2x mt-1 mb-1" @click="closeSession"></button>
      </div>
      <div class="flex-1 relative overflow-scroll w-full h-full">
      <transition-group name="fade" mode="out-in">
        <div v-if="step==0" class="w-full absolute social flex" key="0">
          <div class="flex flex-col w-full mt-1">
            <h2 class="center-text"> {{ $t('registrarse') }} </h2>
            <div class="form-group mt-2 ">
              <label> {{ $t('conemail') }} </label>
              <input v-model="email" class="form-input h-full" type="email" placeholder="Email" pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,14}$">
              <button id="registrointerno" @click="emailCheck" :class="['email', 'w-full', 'btn', 'btn-primary', 'my-2', emailLoading]">
                <label> {{ $t('continuar') }} </label>
              </button>
            </div>
            <div class="flex items-center mt-3 mb-2">
              <div class="line flex-1 mr-2" />
              <label style="color:black; font-size:16px;">{{ $t('redessociales') }}</label>
              <div class="line flex-1 ml-2" />
            </div>
            <div class="form-group2">
              <button id="facebook" @click="socialLogin(facebookProvider)" class="facebook my-2 mdl-button mdl-button--raised flex items-center">
                <img src="@/assets/images/login/facebook.svg" />
                <label>Facebook</label>
              </button>
             <button id="google" @click="socialLogin(googleProvider)" class="google my-2 mdl-button mdl-button--raised flex items-center">
                <img :src="require('@/assets/images/login/google.svg')" />
                <label>Google</label>
              </button>
            </div>
          </div>
        </div>
        <div v-else-if="step==1" class="w-full absolute flex flex-col " key="1">
          <div class="flex items-center">
            <h2 class="mt-2 form-group">{{ $t('ingresapassword') }}</h2>
          </div>
          <div class="flex-1 flex mt-3">
            <div class="flex flex-col w-full">
              <div class="form-group flex-1">
                <label>{{ $t('password') }}</label>
                <input type="password" class="form-input" v-model="loginPass" autocomplete="off">
              </div>
              <div class="flex flex-1 flex mt-2 form-group items-center">
                <div class="flex-1 text">
                  <button @click="recoverPass" class="">{{ $t('olvidadopassword') }}</button>
                </div>
                <div class="flex">
                  <button id="ingresoexitoso" @click="emailLogin" :class="['btn', 'btn-primary', 'w-full', 'mt-2', loginLoading]">{{ $t('register') }}</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else-if="step==2" class="w-full h-full absolute flex flex-col" key="2">
          <h2 class="mt-2 ml-2">{{ $t('crearcuenta') }}</h2>
          <div class="flex-1 flex mt-3">
            <div class="flex flex-col w-full">
              <div class="form-group flex-1">
                <label>{{ $t('password') }}</label>
                <input type="password" class="form-input mb-3" v-model="registerPass" autocomplete="off">
                <label>{{ $t('passwordconfirmation') }}</label>
                <input type="password" class="form-input" v-model="controlPass" autocomplete="off">
                <button @click="emailRegister" :class="['btn', 'btn-primary', 'w-full', 'mt-6', registerLoading]" :disabled="registerPass != controlPass">{{ $t('continuar') }}</button>
              </div>
            </div>
          </div>
        </div>
        <div v-else-if="step==3" class="w-full h-full absolute flex flex-col" key="3">
          <h3 class="mt-2">{{ $t('informacionperfil') }}</h3>
          <div class="flex-1 flex flex-col items-center mt-2">
            <profile-editor v-model="profile" :isNew="true"/>
            <button id="usuarionuevo" @click="storeProfile" :class="['btn', 'btn-primary', 'w-full', 'mt-4', profileLoading]">{{ $t('completar') }}</button>
          </div>
        </div>
      </transition-group>
      </div>
    </div>
  </bvue-ui-view>
</template>

<script>
import {mapActions, mapState} from 'vuex'
import firebase from '@/firebase'
import ProfileEditor from '@/components/ProfileEditor'

export default {
  components: {
    ProfileEditor
  },
  mounted() {
    this.$ga.page('/Registro');
  },
  data () {
    return {
      step: 0,
      email: '',
      loginPass: '',
      registerPass: '',
      controlPass: '',
      profile: {
        name:'',
        image: '',
        country: '',
        isEnterprise: false,
        url: ''
      },
      emailLoading: [],
      loginLoading: [],
      registerLoading: [],
      profileLoading: [],
      facebookProvider: firebase.facebookProvider(),
      twitterProvider: firebase.twitterProvider(),
      googleProvider: firebase.googleProvider()
    }
  },
  methods: {
    ...mapActions('auth', ['login']),
    closeSession() {
      if (this.$store.state.auth.user) {
        this.$store.dispatch('auth/logout')
      }
      this.$store.dispatch('auth/showSession', false)
    },
    goToStep (newStep) {
      this.step = newStep
    },
    socialLogin(provider) {
      firebase.auth.signInWithPopup(provider).then( result => {
        if (result.additionalUserInfo && result.additionalUserInfo.profile) {
          const socialProfile = result.additionalUserInfo.profile
          // console.log(socialProfile)
          if (socialProfile.name) {
            this.profile.name = socialProfile.name
          }
          if (socialProfile.picture) {
            this.profile.image = socialProfile.picture
          }
          if (socialProfile.locale) {
            this.profile.locale = socialProfile.locale
          }
        }
        if (result.additionalUserInfo) {
          console.log("is new user: ", result.additionalUserInfo.isNewUser)
        }
      }).catch( error => {
        console.log('error: ', error)
      });
    },
    emailCheck () {
      this.emailLoading = ['loading', 'disabled']
      firebase.auth.fetchSignInMethodsForEmail(this.email)
      .then( signInMethods => {
        console.log("signInMethods: ", signInMethods)
        this.emailLoading = []
        if (signInMethods.length == 0) {
          //Register
          this.goToStep(2)
        } else if (signInMethods.indexOf(
          firebase.EMAIL_PASSWORD_SIGN_IN_METHOD) != -1) {
          // User can sign in with email/password. Login
          this.goToStep(1)
        } else {
          if (signInMethods.indexOf(
          firebase.GOOGLE_SIGN_IN_METHOD) != -1) {
            var provider = firebase.googleProvider()
            provider.setCustomParameters({
              'login_hint': this.email
            });
            this.socialLogin(provider)
          } else if (signInMethods.indexOf(
          firebase.FACEBOOK_SIGN_IN_METHOD) != -1) {
            var provider = firebase.facebookProvider()
            provider.setCustomParameters({
              'login_hint': this.email
            });
            this.socialLogin(provider)
          } else if (signInMethods.indexOf(
          firebase.TWITTER_SIGN_IN_METHOD) != -1) {
            var provider = firebase.twitterProvider()
            provider.setCustomParameters({
              'login_hint': this.email
            });
            this.socialLogin(provider)
          }
          
        }
      })
      .catch((error) => {
        // Some error occurred, you can inspect the code: error.code
        this.emailLoading = []
        console.log("error: ", error)
        this.$dialogs.alert(this.$t('emailnovalido'), {title: this.$t('erroremailnovalido'), okLabel: ''} )
      });
    },
    async emailLogin() {
      this.loginLoading = ['loading', 'disabled']
      firebase.auth.signInWithEmailAndPassword(this.email, this.loginPass)
      .catch( error => {
        this.loginLoading = []
        console.log('error: ', error)
        this.$dialogs.alert(this.$t('contasenaincorrecta'), {title: this.$t('errorcontrasena'), okLabel: ''} )
      });
    },
    recoverPass() {
      firebase.auth.sendPasswordResetEmail(this.email).then ( (result) => {
        this.$dialogs.alert(this.$t('hemosenviadomail'), {title: this.$t('olvidadopassword'), okLabel: ''} )
      })
    },
    async emailRegister() {
      this.registerLoading = ['loading', 'disabled']
      firebase.auth.createUserWithEmailAndPassword(this.email, this.registerPass)
      .catch( error => {
        this.registerLoading = []
        console.log('error: ', error)
        this.$dialogs.alert(this.$t('usuarionocreado'), {title: 'Error', okLabel: ''} )
        this.goToStep(0)
      });
    },
    async storeProfile() {
      if (this.profile.name.length == 0 || this.profile.country.length == 0) {
        this.$dialogs.alert(this.$t('rellenarcampos'), {title: 'Error', okLabel: ''} )
        return 
      }
      this.profileLoading = ['loading', 'disabled']
      const stored = await this.$store.dispatch('auth/setProfile', this.profile)
      if (!stored) {
        console.log('error: Profile not stored')
        this.$dialogs.alert(this.$t('usuarionoguardado'), {title: 'Error', okLabel: ''} )
        this.profileLoading = []
      }
    }
  },
  watch: {
    '$store.state.auth.user'(newValue, oldValue) {
      console.log('user changed: ', newValue)
      if (newValue) {
        this.loginLoading = []
        this.registerLoading = []
        this.profile.id = newValue.uid
        this.goToStep(3)  
      }
    }, 
    '$store.state.auth.profile'(newValue, oldValue) {
      console.log('profile changed: ', newValue)
      this.$store.dispatch('auth/showSession', false)
    }
  },
  created() {
    // const token = 'eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJhdWQiOiJodHRwczovL2lkZW50aXR5dG9vbGtpdC5nb29nbGVhcGlzLmNvbS9nb29nbGUuaWRlbnRpdHkuaWRlbnRpdHl0b29sa2l0LnYxLklkZW50aXR5VG9vbGtpdCIsImlhdCI6MTU0MTQ0MTU3MSwiZXhwIjoxNTQxNDQ1MTcxLCJpc3MiOiJmaXJlYmFzZS1hZG1pbnNkay04NjU5aEByZWQtZm9yZXN0YWwuaWFtLmdzZXJ2aWNlYWNjb3VudC5jb20iLCJzdWIiOiJmaXJlYmFzZS1hZG1pbnNkay04NjU5aEByZWQtZm9yZXN0YWwuaWFtLmdzZXJ2aWNlYWNjb3VudC5jb20iLCJ1aWQiOiJqcWRySEltcldUWTM2elh4SmNLVXpGY0J6SksyIn0.m6rI3Jwj2yxQgblWBN2rfusQQJw4KMyAY-XGfF2xRnFFI_kN4CZqVFmeTzT175Z9vJmO8t9m05raM3luSHjHnp1qn8zN4lbjsT5NryDBwJpzs-NCEDDP_WqPMz-aTgaERadrFyiFgIpkukcBqOjz3m2ZMhHp-fb4qpK3fO8eTKYZr6chTtk95AMGoYO_KyW_4fTadbax0xvfnby6mgJrRbC-TT2PmSv6dFqCrf-ltgOYYl5UD-BW3jgJQdIQAy_VOE6bu49vbS3hr3ja5fjXc47FSFuA2_PfdnnPJLzluBRLv1ZC9ozJyVZc3QLbGUGAQs-vMwVmzmZqEFQDa0D2KQ'
    // firebase.auth.signInWithCustomToken(token)
    // .then( result => {
    //     console.log('result: ', result)
    //     console.log('result.credential: ', result.credential)
    //     console.log('result.user: ', result.user)
    //   })
    // .catch(function(error) {
    //   // Handle Errors here.
    //   var errorCode = error.code;
    //   var errorMessage = error.message;
    //   // ...
    // });

    if (this.$store.state.auth.user) {
      this.$store.dispatch('auth/logout')
    }
    if (this.$store.state.auth.profile) {
      this.$store.dispatch('auth/showSession', false)
    }
  }
}
</script>

<style lang="scss">
@import '@/style/_variables.scss';

$break-extra-small: 320px;
$break-small: 400px;
$break-large: 1200px;

.form-group {
  padding: 0px 15px;
}

.form-group2 {
  padding: 0px 10px;
}

.overflow-scroll {
  overflow-y:auto;
  overflow-x:hidden;
}

.session-container {
  padding: 15px;
  background-color: white;
  height: 500px;

  h2 {
    color: black;
    font-size: 22px;
    font-weight: 500;
  }
}

.line {
  height: 1px;
  border: solid 1px #dadada;
}

.social button {
  img {
    width: 18px;
    height: 18px;
  }
}

.mdl-button {
  background: 0 0;
  border: none;
  border-radius: 2px;
  color: #000;
  position: relative;
  margin: 0;
  min-width: 64px;
  display: inline-block;
  font-family: Roboto,Helvetica,Arial,sans-serif;
  font-size: 14px;
  text-transform: uppercase;
  letter-spacing: 0;
  overflow: hidden;
  will-change: box-shadow;
  transition: box-shadow .2s cubic-bezier(.4,0,1,1),background-color .2s cubic-bezier(.4,0,.2,1),color .2s cubic-bezier(.4,0,.2,1);
  outline: 0;
  cursor: pointer;
  text-decoration: none;
  vertical-align: middle;

  direction: ltr;
  font-weight: 500;
  height: auto;
  line-height: normal;
  // max-width: 220px;
  min-height: 40px;
  padding: 8px 16px;
  text-align: left;
  width: 100%;

  label {
    color: #fff;
    font-size: 14px;
    padding-left: 16px;
    text-transform: none;
    vertical-align: middle;
  }

}

.mdl-button--raised {
    background: rgba(158,158,158,.2);
    box-shadow: 0 2px 2px 0 rgba(0,0,0,.14), 0 3px 1px -2px rgba(0,0,0,.2), 0 1px 5px 0 rgba(0,0,0,.12);
}

.email {
  background-color: $primary-color;
}

.facebook {
  background-color: #3b5998;
}

.twitter {
  background-color: #55acee;
}

.google {
  background-color: white;
  label {
    color: #757575
  }
}

.fullPage {
  background-color: rgba(0, 0, 0, 0.75)
}
.session-container {
  border-radius: 3px;
  width: 600px;
  border: 1px solid #ddd;
  max-width: 90%;
  max-height: 90%;
  padding: 30px !important;
  min-height: 470px !important;
  height: auto !important;
  @media screen and (max-width: $break-extra-small) {
    max-width: 95%;
    max-height: 95%;
  }
  form {
    padding: 5%;
  }
}
</style>




// WEBPACK FOOTER //
// src/pages/Session.vue